import { useEffect } from "react";
import { useState } from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import CartonBoxIcon from "src/assets/CartonBox";
import Bag from "src/assets/Bag";
import CreditCardIcon from "src/assets/CreditCard";
import UserIcon from "src/assets/User";
import WrenchIcon from "src/assets/Wrench";
import Config from "src/pages/Woocommerce/Config";
import Customers from "src/pages/Woocommerce/Customers";
import Orders from "src/pages/Woocommerce/Orders";
import Products from "src/pages/Woocommerce/Products";
import DeskeraInventoryTransaction from "./DeskeraInventoryTransaction";
import DeskeraProducts from "./DeskeraProducts";

function Woocommerce() {
  const [activeVisible, setActiveVisible] = useState(false);
  const [activeTop, setActiveTop] = useState(0);

  useEffect(() => {
    sessionStorage.setItem("cartType", "woocommerce");
  });

  const menuItems = [
    {
      name: "Setup",
      href: "/app/woocommerce",
      icon: <WrenchIcon />,
      component: <Config />,
      exact: true,
    },
    {
      name: "Orders",
      href: "/app/woocommerce/orders",
      icon: <CreditCardIcon />,
      component: <Orders />,
      exact: false,
    },
    {
      name: "Customers",
      href: "/app/woocommerce/customers",
      icon: <UserIcon />,
      component: <Customers />,
      exact: false,
    },
    {
      name: "Products",
      href: "/app/woocommerce/products",
      icon: <CartonBoxIcon />,
      component: <Products />,
      exact: false,
    },
    {
      name: "Deskera Products",
      href: "/app/woocommerce/deskeraproducts",
      icon: <CartonBoxIcon />,
      component: <DeskeraProducts/>,
      exact: false,
    },
    {
      name: "Inventory Transaction",
      href: "/app/woocommerce/deskerainventorytransaction",
      icon: <Bag />,
      component: <DeskeraInventoryTransaction/>,
      exact: false,
    }
  ];

  return (
    <>
      <div
        className="bg-white py-3 dk-shadow-sm"
        style={{
          minWidth: 240,
          borderRight: "1px solid rgba(0, 0, 0, 0.1)",
          zIndex: 9,
          position: "relative",
        }}
      >
        {activeVisible && (
          <div
            className="ease-in-out-back"
            style={{
              width: 8,
              height: "3.25rem",
              position: "absolute",
              right: 0,
              top: activeTop,
              backgroundColor: "#4962df",

            }}
          ></div>
        )}
        {menuItems.map((item, index) => (
          <NavLink
            exact
            to={item.href}
            className="text-decoration-none px-4 py-3 d-block dk-navlink dk-navlink-hover mb-2 ease-in"
            isActive={(match, location) => {
              if (!match) return false;
              setActiveVisible(true);
              setActiveTop(1 + (3.375 + 0.5) * index + "rem");
              return true;
            }}
            style={{
              fontWeight: 500,
              color: "black"
            }}
          >
            <span className="svg-icon-lg svg-baseline mr-3">{item.icon}</span>
            {item.name}
          </NavLink>
        ))}
      </div>
      <div className="w-100 h-100 overflow-auto" style={{ background: "#f6f6f6" }}>
        <Switch>
          {menuItems.map((item) => (
            <Route exact={item.exact} path={item.href}>
              {item.component}
            </Route>
          ))}
        </Switch>
      </div>
    </>
  );
}

export default Woocommerce;
